import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Indicator from '../../../../../models/Indicator';
import { IndicatorKeyEnum } from '../../../../../models/IndicatorKeyEnum';
import { callIndicatorFromDetail } from '../../../PortfolioUtil';
import './ProgressBarIndicatorProjection.scss';
import { formatMillionNumber } from '../../../../../services/numberUtil';

interface ReceivedProps {
  data: any;
  showDisbursed?: any;
}

type Props = ReceivedProps;

const ProgressBarIndicatorProjection = (props: Props) => {
  const currentIndicator = useSelector<any, Indicator>(state => state.currentIndicator);
  const dispatch = useDispatch();
  const projectTypeFilterOnDetail = useSelector<any, any>(
    state => state.indicatorDetailFilter.projectTypeFilterOnDetail,
  );
  const { data, showDisbursed } = props;
  const progress = data ? `${data.progress}%` : '';
  const leftProgress = data ? `${100 - data.progress}%` : '';
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (currentIndicator.indicatorKey !== 'default_indicator' && location.pathname === '/portfoliodetail') {
      callIndicatorFromDetail(IndicatorKeyEnum.DISBURSEMENTS_AND_PROJECTIONS_FOR_THE_YEAR, dispatch);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectTypeFilterOnDetail]);

  const handleDisbursed = () => {
    showDisbursed(true);
  };

  const handlePending = () => {
    showDisbursed(false);
  };

  return data ? (
    <div className="progress-bar-indicator-container">
      <div className="progress-bar-container">
        <div style={{ width: progress }} className="progress">
          <div className="progress-text" onClick={handleDisbursed}>
            <span className="porcent-num">{progress}</span>
          </div>
        </div>

        {data.progress < 100 && (
          <div style={{ width: leftProgress }} className="left-progress-text" onClick={handlePending}>
            <span className="porcent-num">{leftProgress}</span>
          </div>
        )}
      </div>
      <ul className="list-info">
        <li className={data.disbursed !== 0 ? 'color-data' : ''} onClick={handleDisbursed}>
          <NumberFormat
            value={formatMillionNumber(data.disbursed)}
            displayType={'text'}
            thousandSeparator={'.'}
            decimalSeparator={','}
            decimalScale={1}
          />
          <span className="currency">{data.currency}</span>
        </li>
        <li onClick={handlePending}>
          <NumberFormat
            value={formatMillionNumber(data.pending)}
            displayType={'text'}
            thousandSeparator={'.'}
            decimalSeparator={','}
            decimalScale={1}
          />
          <span className="currency">{data.currency}</span>
        </li>
      </ul>
      <div className="text-info-progress">
        <div>{`${t('disbursed')} `}</div>
        <div>{`${t('pending').replace(/(^|\s)\S/g, l => l.toUpperCase())} `}</div>
      </div>
      <div className="planned_project">
        {`${t('original_disbursements_annual_projection').replace(/(^|\s)\S/g, l => l.toUpperCase())} `}
        <NumberFormat
          value={formatMillionNumber(data.original_project)}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          decimalScale={1}
        />
        <span className="currency">{data.currency_project}</span>
      </div>
      <div className="planned_project">
        {`${t('current_projection').replace(/(^|\s)\S/g, l => l.toUpperCase())} `}
        <NumberFormat
          value={formatMillionNumber(data.current_project)}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          decimalScale={1}
        />
        <span className="currency">{data.currency_project}</span>
      </div>
      <div className="planned_project">
        {`${t('deviation').replace(/(^|\s)\S/g, l => l.toUpperCase())} `}
        <NumberFormat
          value={formatMillionNumber(data.detour)}
          displayType={'text'}
          thousandSeparator={'.'}
          decimalSeparator={','}
          decimalScale={1}
        />
        <span className="currency">{data.currency_project}</span>
        <span className="container_percentage">{Math.round(data.percentage)}%</span>
      </div>
    </div>
  ) : (
    <div className="no-data-msj-indicator">
      <span className="value-text">-</span>
    </div>
  );
};

export { ProgressBarIndicatorProjection };
